import { PaginationRes } from "@/app/api/types";
import { IconButton, Text } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@saas-ui/react";

export const Pagination = ({
  page,
  page_size,
  count,
  onPageChange,
}: PaginationRes & {
  onPageChange: (page: number) => void;
}) => {
  const nbPages = Math.ceil(count / page_size);
  return (
    <div className="flex justify-center items-center gap-x-6">
      <IconButton
        disabled={page === 1}
        data-cy="prev-page-button"
        aria-label="Previous page"
        icon={<ChevronLeftIcon />}
        onClick={() => onPageChange(page - 1)}
      />
      <Text fontSize="sm">
        Page {page} of {Math.ceil(count / page_size)} ({count} rows)
      </Text>
      <IconButton
        disabled={page === nbPages}
        data-cy="next-page-button"
        aria-label="Next page"
        icon={<ChevronRightIcon />}
        onClick={() => onPageChange(page + 1)}
      />
    </div>
  );
};
